// extracted by mini-css-extract-plugin
module.exports = {"container":"SideDrawer_container__2J5Ev","outside":"SideDrawer_outside__2Q9oC","side-drawer":"SideDrawer_side-drawer__C4W7z","close-button":"SideDrawer_close-button__1Y8N-"};